import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import React from 'react';
import PropTypes from 'prop-types';
import { BsX } from 'react-icons/bs';

export default function CommonModal({
  open = false,
  setOpen,
  children,
  modalClasses,
  modalPosition = 'center',
}) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-[99999]" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div
          className={`fixed z-[99999] overflow-y-auto ${
            modalPosition === 'center' ? 'inset-0' : 'top-0 right-0 left-0'
          }`}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6 ${modalClasses}`}
              >
                <div className="absolute top-4 right-4" onClick={setOpen}>
                  <BsX className="cursor-pointer text-3xl text-gray-500 hover:text-red-600" />
                </div>
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

CommonModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  children: PropTypes.any,
  modalClasses: PropTypes.string,
  modalPosition: PropTypes.string,
};
